import { Store } from "@tanstack/store";
import type {
	ModalDataMap,
	TModalKeys,
} from "@/components/common/modals/modal-provider";

interface ModalState {
	isOpen: boolean;
	modalKey: TModalKeys | null;
	data: ModalDataMap[TModalKeys] | Record<string, unknown>;
}

const initialState: ModalState = {
	isOpen: false,
	modalKey: null,
	data: {},
};

export const modalStore = new Store<ModalState>(initialState);

export function openModal<TKey extends TModalKeys>(
	key: TKey,
	data: ModalDataMap[TKey],
): void {
	modalStore.setState(() => ({
		isOpen: true,
		modalKey: key,
		data: data,
	}));
}

export function closeModal(): void {
	modalStore.setState(() => initialState);
}

export function getModalState(): ModalState {
	return modalStore.state;
}
